<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addFeedback()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                    [disabled]="freeSubjects().length === 0"
                >
                    <mat-icon>add</mat-icon>
                    {{ 'new_record' | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="filter-item">
                    <pixl-free-filter-input
                        [label]="'subject' | transloco"
                        [matIcon]="'search'"
                        [hint]="getSearchFilterHint()"
                        [minLength]="freeFilterLen"
                        (onKeyUpChange)="setFreeFilter($event)"
                    />
                </div>

            </div>
            <div class="main-toolbar-spacer-right"></div>
        </div>
        <div class="table-header-overlay"></div>
    </div>
    <div class="table-container mat-elevation-z4">
        @if (feedbackRows$ | async; as rows) {
        @if (rows.length > 0) {
        <table
            mat-table
            [dataSource]="rows"
            [trackBy]="trackById"
            matSort
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ 'actions' | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let feedback"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        [attr.aria-label]="'edit_record_hint' | transloco"
                        type="button"
                        (click)="editFeedback(feedback)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        [attr.aria-label]="'delete_record_hint' | transloco"
                        type="button"
                        (click)="deleteFeedback(feedback)"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="subject">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="subject"
                >{{ 'subject' | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let row"
                >
                    {{ row.subjectName }}
                </td>
            </ng-container>

            <ng-container matColumnDef="updated">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="updated"
                >{{ 'updated' | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let row"
                >
                    {{ row.updated ? (row.updated | date:'medium') : '---' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="changedBy">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header="changedBy"
                >{{ 'changed_by' | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let row"
                >
                    {{ row.changedBy || '---' }}
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        } @else {
        <div class="empty-state">
            {{ 'feedback_no_entries' | transloco }}
        </div>
        }
        } @else {
        <pixl-table-loading-spinner [name]="'Rückmeldungen'"></pixl-table-loading-spinner>
        }
        <mat-paginator
            [pageIndex]="pageChange().pageIndex"
            [pageSize]="pageChange().pageSize"
            [pageSizeOptions]="[25, 50, 100]"
            [length]="totalItems">
        </mat-paginator>
    </div>
</div>